import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  Paper,
} from '@mui/material';
import { styled } from '@mui/system';
import axios from 'axios';
import { Navigate, Link, useNavigate } from 'react-router-dom';

const StyledPaper = styled(Paper)(({ theme }) => ({
  
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
  maxWidth: '400px',
  margin: 'auto',
  marginTop: theme.spacing(8),
}));
 
const LoginOTP = ({ isAuthenticated }) => {
  
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
    const [otpSent, setOtpSent] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false); 
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError('');
    setSuccess('');
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
    setError('');
      setSuccess('');
  };
 
  const handleGetOtp = async () => {
    if (otpSent) {
      handleVerifyOtp();
      return;
    }
    if (!email) {
      setError('Please enter your email address.');
      return;
    }

    try {
      const response = await axios.post('/api/auth/send-otp', { email });
      if (response.status === 200) {
        setSuccess('OTP has been sent to your email');
        setError('');
        setOtpSent(true);
        setShowOtpInput(true);
      } else {
        setError(response.data.message || 'Failed to send OTP');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send OTP.');
    }
  }; 

 
  const handleVerifyOtp = async () => {
    if (!otp) {
      setError('Please enter the OTP.');
      return;
    }
   
    try {
      const response = await axios.post('/api/auth/verify-otp', { email, otp });
      if (response.status === 200) {
         console.log('OTP Login successful, response:', response.data);
         console.log('Storing token and user role...');
         localStorage.setItem('token', response.data.token);
         localStorage.setItem('userRole', response.data.user.role_id);
         console.log('Token and user role stored successfully.');
         console.log('Navigating to /dashboard...');
         navigate('/dashboard');
        console.log('Navigation call executed.');
      } else {
        console.error('OTP Login failed, response:', response);
        setError(response.data.message || 'Invalid OTP');
      }
    } catch (err) {
        console.error(
          'Error during OTP verification:', err
        );
      setError(
        err.response?.data?.message || 'Failed to verify OTP. Please try again.'
      );
    }
  };
  if (isAuthenticated || isLoggedIn) {
    return <Navigate to="/dashboard" />;
  }
  return (
    <Container component="main" maxWidth="sm">
      <StyledPaper elevation={3}> 
       <Box mb={2}>
          <Link to="/login" style={{ textDecoration: 'none' }}>Back to Login</Link>
        </Box>
        <Typography component="h1" variant="h5" align="center" color="primary">
          Login via OTP
        </Typography>
        <Box mt={2}>
          {error && <Alert severity="error">{error}</Alert>}
          {success && (
            <Alert severity="success">{success}</Alert>
          )}
          <TextField 
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            value={email}
            onChange={handleEmailChange}
          />
           {showOtpInput && ( 
             <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="otp"
                label="OTP"
                name="otp"
                value={otp}
                onChange={handleOtpChange}
              />
            )}
           <Box mt={2}> 
          <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleGetOtp}
              sx={{ mt: 2 }}>
              {otpSent ? 'Login' : 'Get OTP'}
            </Button>
         </Box>
        
        </Box>
      </StyledPaper>
    </Container>
  );
};
export default LoginOTP;